/**
 * Le mot de bienvenue, entre l'inscription et la première page — §317.
 *
 * **Pourquoi il ne peut pas être un état de composant.** L'écran qui crée le
 * compte DISPARAÎT au moment où le compte est créé : la session s'ouvre,
 * `['me']` répond, et l'application bascule sur le tunnel d'accueil. Un état
 * porté par l'écran d'inscription serait donc démonté avant d'avoir été lu, et
 * le candidat entrerait sans qu'on lui ait dit un mot.
 *
 * **Ni un paramètre d'adresse, ni le stockage local.** Le premier resterait
 * dans la barre du navigateur et se partagerait par copier-coller ; le second
 * survivrait au rechargement, et souhaiterait la bienvenue à quelqu'un qui
 * revient depuis trois semaines.
 *
 * Une variable de module vit exactement le temps qu'il faut : celui d'un
 * chargement de page. C'est le même mécanisme que `raisonDeLaDeconnexion`, et
 * pour la même raison.
 */

let pseudonyme: string | null = null

/** Retient à qui souhaiter la bienvenue, au moment où son compte est créé. */
export function retenirLaBienvenue(pseudo: string): void {
  pseudonyme = pseudo
}

export function bienvenue(): string | null {
  return pseudonyme
}

/**
 * **Se lit une fois.** Un message de bienvenue qui reparaît à chaque retour sur
 * l'écran cesse d'être un accueil et devient un meuble.
 */
export function oublierLaBienvenue(): void {
  pseudonyme = null
}
